/* TC Variant Sync (exact option names)
   Lets the theme handle price/availability by selecting the right variant.
   Option names:
     - Jewelry Type: Small/Medium/Large Round Necklace, Earrings, Cufflinks, Tie Bar
     - Jewelry Material: Sterling Silver, Gold Vermeil, 14K Yellow Gold, 14K Rose Gold
     - Chain Length: 18 inches, 28 inches
*/
(function () {
  const norm = s => String(s || '').trim().toLowerCase();

  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  function getForm() {
    const tool = document.getElementById('tc-map-tool');
    return (tool && tool.closest('form.product_form')) ||
           document.querySelector('form.product_form') ||
           document;
  }

  function getProductJson(form) {
    try {
      const raw = form && form.getAttribute && form.getAttribute('data-product');
      return raw ? JSON.parse(raw) : null;
    } catch (_){ return null; }
  }

  function getOptionSelect(form, optionName) {
    return form.querySelector(`select[name="options[${optionName}]"]`);
  }

  function setSelectByText(select, wantedText) {
    if (!select) return;
    const want = norm(wantedText);
    let idx = -1;
    for (let i = 0; i < select.options.length; i++) {
      const txt = norm(select.options[i].text || select.options[i].value);
      if (txt === want) { idx = i; break; }
    }
    if (idx >= 0 && select.selectedIndex !== idx) {
      select.selectedIndex = idx;
      try { select.dispatchEvent(new Event('change', { bubbles: true })); } catch(_){}
    }
  }

  function normalizeChainLabel(label) {
    const s = norm(label);
    if (s.includes('18"') || s === '18' || s.includes('18 inches')) return '18 inches';
    if (s.includes('28"') || s === '28' || s.includes('28 inches')) return '28 inches';
    return label; // pass-through
  }

  function readSelectedOptions(form) {
    const sels = Array.from(form.querySelectorAll('select[name^="options["]'));
    return sels.map(s => (s.options[s.selectedIndex]?.text || s.value || '').trim());
  }

  function findVariant(product, selectedOptions) {
    if (!product || !Array.isArray(product.variants)) return null;
    const N = (product.options || []).length;
    if (!N || selectedOptions.length !== N) return null;
    const n = x => String(x || '').trim().toLowerCase();
    return product.variants.find(v => {
      if (!v.options || v.options.length !== N) return false;
      for (let i = 0; i < N; i++) { if (n(v.options[i]) !== n(selectedOptions[i])) return false; }
      return true;
    }) || null;
  }

  function syncVariantIdAndNotify() {
    const form = getForm(); if (!form) return;
    const prod = getProductJson(form); if (!prod) return;

    const selected = readSelectedOptions(form);
    const variant  = findVariant(prod, selected);
    if (!variant) return;

    const idField = form.querySelector('select[name="id"], input[name="id"]');
    if (idField && idField.value !== String(variant.id)) {
      idField.value = String(variant.id);
      try { idField.dispatchEvent(new Event('change', { bubbles: true })); } catch(_){}
    }

    // Let the theme update price/availability/UI
    try {
      form.dispatchEvent(new CustomEvent('shopify:variant:change', { bubbles: true, detail: { variant, product: prod } }));
    } catch(_){}
    try {
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant, product: prod, form } }));
    } catch(_){}
  }

  // ---------- Wire to your controls ----------

  // MATERIAL swatches (.tc-swatch)
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.tc-swatch'); if (!sw) return;
    const label = (sw.getAttribute('data-material') || sw.textContent || '').trim();
    const form  = getForm();
    const sel   = getOptionSelect(form, 'Jewelry Material');
    setSelectByText(sel, label);
    setTimeout(syncVariantIdAndNotify, 0);
  });

  // CHAIN pills (.tc-pills .tc-pill)
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('.tc-pills .tc-pill'); if (!pill) return;
    const raw  = (pill.getAttribute('data-chain') || pill.textContent || '').trim();
    const label = normalizeChainLabel(raw);
    const form  = getForm();
    const sel   = getOptionSelect(form, 'Chain Length');
    // Some products (earrings/cufflinks/tie bar) might not have chain length
    if (sel) {
      setSelectByText(sel, label);
      setTimeout(syncVariantIdAndNotify, 0);
    }
  });

  // SHAPE / TYPE switcher (listens to your existing tc-shape-change)
  document.addEventListener('tc-shape-change', (e) => {
    const form = getForm();
    const label = (e.detail && (
      e.detail.title || e.detail.shape || e.detail.product
    ) || '').toString().trim();
    if (!label) { setTimeout(syncVariantIdAndNotify, 0); return; }
    const sel = getOptionSelect(form, 'Jewelry Type');
    setSelectByText(sel, label);
    setTimeout(syncVariantIdAndNotify, 0);
  });

  // If customer uses the theme’s selects directly, keep in sync
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (el && el.matches && el.matches('select[name="options[Jewelry Type]"], select[name="options[Jewelry Material]"], select[name="options[Chain Length]"], select[name="id"]')) {
      setTimeout(syncVariantIdAndNotify, 0);
    }
  });

  // First paint
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(syncVariantIdAndNotify, 0));
  } else {
    setTimeout(syncVariantIdAndNotify, 0);
  }
})();

//open correct overlay

(function(){
  const ready=(cb)=>document.readyState==='loading'
    ? document.addEventListener('DOMContentLoaded',cb)
    : cb();

  ready(function(){
    const u=new URL(location.href), q=u.searchParams;
    const clean=v=>{try{return decodeURIComponent((v??'')).replace(/\s+/g,' ').trim();}catch(_){return String(v??'').replace(/\s+/g,' ').trim();}};
    const norm=s=>String(s||'').toLowerCase().trim();
    const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>Array.from(r.querySelectorAll(s));

    // NEW: canonicalize chain values like 28", 28 in, 28 inches, n/a
    const canonChain=(s)=>{
      const v=String(s||'').toLowerCase().replace(/\s+/g,' ').trim();
      if(!v) return '';
      if(v==='n/a'||v==='na') return 'n/a';
      const m=v.match(/(\d+)\s*(?:\"|in|inch|inches)?/);
      if(!m) return v;
      const n=m[1];
      return (n==='18') ? '18 inches'
           : (n==='28') ? '28 inches'
           : `${n} inches`;
    };

    // — 1) Canonicalize the URL once (collapse extra %20/space runs)
    let changed=false;
    ['jt','metal','chain','variant','ms','open'].forEach(k=>{
      if(!q.has(k)) return;
      const v=q.get(k), w=clean(v);
      if(w!==v){ q.set(k,w); changed=true; }
      if(k==='variant' && w && !/^\d+$/.test(w)){ q.delete('variant'); changed=true; }
    });
    if(changed){ u.search=q.toString(); history.replaceState(null,'',u); }

    // — 2) Read params
    const jt=clean(q.get('jt')), metal=clean(q.get('metal'));
    let chain=canonChain(clean(q.get('chain')));  // UPDATED: use canonChain here
    const ms=clean(q.get('ms'));

    // — 3) Map-first: ensure the overlay is closed
    (function(){
      const wrap=$('#tc-map-tool'), ov=$('#pendant3d-overlay'), open=$('#tc-btn-open'), close=$('#tc-btn-close');
      wrap&&wrap.classList.remove('overlay-open');
      if(ov){ ov.style.display='none'; ov.setAttribute('aria-hidden','true'); }
      if(open) open.style.display='';
      if(close) close.style.display='none';
      try{ document.dispatchEvent(new CustomEvent('tc:pendant-closed')); }catch(_){}
    })();

    // — 4) Restore map center (lng,lat,zoomMB)
    if(ms && window.map){
      try{
        const [lngS,latS,zS]=ms.split(',');
        const lng=parseFloat(lngS), lat=parseFloat(latS), z=parseFloat(zS);
        if(!isNaN(lat)&&!isNaN(lng)) window.map.setView([lat,lng], isNaN(z)?window.map.getZoom():(z+1));
      }catch(_){}
    }

    // Helper: safe “user” click (lets your theme handlers run)
    const click = (el)=>{ try{ el && el.dispatchEvent(new MouseEvent('click',{bubbles:true,cancelable:true})); }catch(_){ } };

    // — 5) Apply Jewelry Type by clicking the correct tile (drives overlay + internal state)
    if(jt){
      const tile = $$('.tc-tile').find(t=>norm((t.getAttribute('data-shape')||t.textContent||'').trim())===norm(jt));
      click(tile); setTimeout(()=>click(tile),30); // tiny stagger for late listeners
      setTimeout(()=>{ try{ document.dispatchEvent(new CustomEvent('tc-shape-change')); }catch(_){ } },45);
    }

    // Chain normalization for non-necklaces coming from URL
    if(/(earrings|cufflinks|tie\s*bar)/i.test(jt)) chain=canonChain('N/A');  // UPDATED

    // — 6) Apply Material by clicking the matching swatch (no manual class tweaks)
    if(metal){
      const sw = $$('.tc-swatch').find(s=>norm(s.getAttribute('data-material'))===norm(metal))
              || $$('.tc-swatch').find(s=>norm(s.textContent)===norm(metal));
      click(sw);
    }

    // — 7) Apply Chain by clicking the matching pill
    if(chain){
      const pill = $$('.tc-pills .tc-pill').find(p=>canonChain(p.getAttribute('data-chain'))===chain) // UPDATED
                || $$('.tc-pills .tc-pill').find(p=>canonChain(p.textContent)===chain);               // UPDATED
      click(pill);
    }

    // — 8) After the above “clicks” run handlers, ask your sync to recompute once
    const sync=()=>{ if(window.TCVariantSync && typeof TCVariantSync.sync==='function'){ TCVariantSync.sync(); } };
    setTimeout(sync,100);

    // — 9) SCRUB selection params so future adds use current UI only (keep ms)
    const scrub=()=>{
      const u2=new URL(location.href), q2=u2.searchParams;
      ['jt','metal','chain','variant','open'].forEach(k=>q2.delete(k));
      u2.search = q2.toString(); history.replaceState(null,'',u2);
    };
    // scrub once after applying URL state
    setTimeout(scrub,120);

    // IMPORTANT: no further listeners, no writing to selects/variant — let your theme handle user changes
  });
})();

//new



